import { makeAutoObservable } from "mobx";
import { IRootStore } from "../../../mobx/root-store";
import { ITgDatasetStore, TgDatasetStore } from "../Datasets/store/tg-dataset-store";
import { ITgModelPlaygroundStore, TgModelPlaygroundStore } from "../Models/store/tg-model-playground-store";
import { ITgModelStore, TgModelStore } from "../Models/store/tg-model-store";
import { ITgProjectStore, TgProjectStore } from "../Projects/store/tg-projects-store";

export interface ITgStore {
	tgProjectStore: ITgProjectStore;
	tgModelStore: ITgModelStore;
	tgModelPlaygroundStore: ITgModelPlaygroundStore;
	tgDatasetStore: ITgDatasetStore;
	rootStore: IRootStore;

	selectedAppConfig: TgAppConfigs;
}

export class TgStore implements ITgStore {
	tgProjectStore: ITgProjectStore;
	tgModelStore: ITgModelStore;
	tgDatasetStore: ITgDatasetStore;
	tgModelPlaygroundStore: ITgModelPlaygroundStore;
	rootStore: IRootStore;

	selectedAppConfig: TgAppConfigs = "image";

	constructor(rootStore: IRootStore) {
		this.tgProjectStore = new TgProjectStore(this);
		this.tgModelStore = new TgModelStore(this);
		this.tgModelPlaygroundStore = new TgModelPlaygroundStore(this);
		this.tgDatasetStore = new TgDatasetStore(this);
		this.rootStore = rootStore;
		makeAutoObservable(this);
	}
}

export type TgAppConfigs = "image" | "video";
